import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/",
        redirect: "/home"
    },
    // 产品详情
    {
        path: "/product/:id",
        name: "ProductDetail",
        component: () => import("@/views/productDetail/index.vue")
    },
    {
        path: "/home",
        name: "Home",
        component: () => import("@/views/home/index.vue")
    },
    // 仿真模型页
    {
        path: "/simulationModelPage",
        name: "SimulationModelPage",
        component: () => import("@/views/simulation-model-page/index.vue")
    },
    {
        path: "/index",
        name: "index",
        component: () => import("@/views/index.vue"),
        redirect: "/products",
        children: [
            // 产品列表
            {
                path: "/products",
                name: "ProductList",
                component: () => import("@/views/productList/index.vue")
            },
            {
                path: "/related/products",
                name: "RelatedProductList",
                component: () => import("@/views/relatedProductList/index.vue")
            },
            // 品牌详情
            {
                path: "/brand/:id",
                name: "BrandDetail",
                component: () => import("@/views/brandDetail/index.vue")
            },
            {
                path: "/compare/:type",
                name: "Compare",
                component: () => import("@/views/compare/index.vue"),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: "/user",
                name: "User",
                component: () => import("@/views/user/index.vue"),
                redirect: "/user/collect",
                meta: {
                    requireAuth: true
                },
                children: [
                    {
                        // 我的收藏
                        path: "collect",
                        name: "Collect",
                        component: () => import("@/views/user/UserCollect.vue")
                    },
                    {
                        // 待更新
                        path: "tobeUpdate",
                        name: "ToBeUpdate",
                        component: () => import("@/views/user/UserUpdate.vue")
                    },
                    {
                        // 已下载
                        path: "downloaded",
                        name: "Downloaded",
                        component: () => import("@/views/user/UserDownloaded.vue")
                    },
                    {
                        // 品牌
                        path: "brand",
                        name: "Brand",
                        component: () => import("@/views/user/UserBrand.vue")
                    },
                    {
                        // 消息
                        path: "news",
                        name: "News",
                        component: () => import("@/views/user/UserNews.vue")
                    },
                    {
                        // 个人信息
                        path: "userinfo",
                        name: "Userinfo",
                        component: () => import("@/views/user/UserInfo.vue")
                    }
                ]
            },
            // BIM工具
            {
                path: "/bimtool",
                name: "BimTool",
                component: () => import("@/views/bimtool/index.vue")
            },
            // 关于制造商
            {
                path: "/about-manufacturer",
                name: "AboutManufacturer",
                component: () => import("@/views/manufacturer/index.vue")
            },
            {
                path: "/search-results",
                name: "SearchResults",
                component: () => import("@/views/searchResults/index.vue")
            },
            // 关于我们
            {
                path: "/about",
                name: "About",
                component: () => import("@/views/aboutUs/index.vue")
            },
            // 定制仿真
            {
                path: "/customSimulation",
                name: "CustomSimulation",
                component: () => import("@/views/CustomSimulation/index.vue")
            },
            // 仿真主页
            {
                path: "/simulationHomePage",
                name: "SimulationHomePage",
                component: () => import("@/views/simulation-home-page/index.vue")
            },

            // 作业
            {
                path: "/home-work",
                name: "HomeWork",
                component: () => import("@/views/homeWork/index.vue")
            },
            // 作业资料-内页
            {
                path: "/task-file",
                name: "TaskFile",
                component: () => import("@/views/taskFile/index.vue")
            },
            // 教学资源
            {
                path: "/teachResource",
                name: "TeachResource",
                component: () => import("@/views/teachingResources/index.vue")
            },
            // 找回密码
            {
                path: "/findPassword",
                name: "FindPassword",
                component: () => import("@/views/FindPassword.vue")
            },
            {
                path: "*",
                name: "page404",
                meta: { menu: false },
                component: () => import("@/views/Page404.vue")
            }
        ]
    },
    {
        path: "/error",
        name: "Error",
        component: () => import("@/views/error/index.vue")
    },
    {
        path: "/model-view",
        name: "Model",
        component: () => import("@/views/model-view/index.vue")
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
